import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function Transformation() {
  return <section className="py-8 md:py-12 bg-[#9d4b6b] text-white relative overflow-hidden" data-id="element-197">
      {/* Decorative background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-198">
        <svg width="100%" height="100%" xmlns="http://www.w3.org/2000/svg" data-id="element-199">
          <defs data-id="element-200">
            <pattern id="flower" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-201">
              <circle cx="20" cy="20" r="1" fill="currentColor" data-id="element-202" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#flower)" data-id="element-203" />
        </svg>
      </div>

      <div className="max-w-4xl mx-auto px-6 relative z-10" data-id="element-204">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-12" data-id="element-205">
          <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif mb-8 tracking-wide" data-id="element-206">
            IMAGINA ALGO DISTINTO
          </h2>
          <div className="w-24 h-1 bg-white/30 mx-auto rounded-full" data-id="element-207"></div>
        </motion.div>

        <div className="grid md:grid-cols-2 gap-12 items-center mb-8" data-id="element-208">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.8
        }} className="space-y-6 text-lg md:text-xl font-light leading-relaxed" data-id="element-209">
            <p data-id="element-210">
              Despiertas una mañana y notas algo diferente. Él te mira con una
              chispa familiar, como cuando se enamoró de ti. Te sonríe. Te
              abraza por la cintura en la cocina. Se interesa de nuevo en ti.
            </p>
            <p data-id="element-211">
              Las conversaciones vuelven a fluir. Las risas regresan. La
              complicidad revive.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4,
          duration: 0.8
        }} className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 shadow-xl" data-id="element-212">
            <p className="text-lg md:text-xl mb-6" data-id="element-213">
              Sientes que vuelves a ser mujer, no solo mamá. Sientes que vuelves
              a ser su compañera, no solo su responsabilidad. Sientes que el
              amor renace.
            </p>
            <p className="font-serif text-2xl italic" data-id="element-214">
              Y tú sabes que ese renacer sucedió porque tomaste una decisión.
            </p>
          </motion.div>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.6
      }} className="text-center" data-id="element-215">
          <CTAButton scrollToPurchase data-id="element-216">Ver Cómo Lograrlo</CTAButton>
        </motion.div>
      </div>
    </section>;
}